import ConfigDB from '../../../Config/ThemeConfig';

const primary = ConfigDB.color.primary_color;
const secondary = ConfigDB.color.secondary_color;
export const SaleCardData2 = [
  {
    title: 'SALE',
    gros: 90,
    price: '$3654.00',
    chartSeries: [4, 6, 8, 6, 10, 12, 14],
    chartColor: primary,
    statusColor: 'primary',
  },
  {
    title: 'PROJECTS',
    gros: 30,
    price: 12569,
    chartSeries: [6, 2, 10, 8, 4, 12, 14],
    chartColor: secondary,
    statusColor: 'secondary',
  },
  {
    title: 'PRODUCTS',
    gros: 90,
    price: '93M',
    chartSeries: [16, 14, 10, 12, 10, 12, 8],
    chartColor: primary,
    statusColor: 'primary',
  },
];
